import React, { useEffect, useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

import { EyeIcon } from '../../../utils/TableActionIcons';
import { viewFormEntriesTableColumns } from '../../../constants/FormCreationConstants';
import CustomTable from '../../../shared/CustomTable';
import useFetchData from '../../../hooks/UseFetchData';
import { labModuleApi } from '../../../helpers/labModuleApi';
import { formatDateTime } from '../../../utils/FormateDateTime';
import FormsResultsPreviewTable from './FormsResultsPreviewTable';
import { useTranslation } from 'react-i18next';
const ReusableModal = React.lazy(() => import('../../../shared/ReuseableModal'));

const ViewGeneralFormEntries = props => {
  const { data, loading, executeFetch } = useFetchData();
  const [selectedPatientFormData, setSelectedPatientFormData] = useState(null);
  const { t } = useTranslation()
  const [openViewFormDataModal, setOpenViewFormDataModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const actionsColumn = {
    body: actionsTemplate,
    header: t('Actions'),
    headerCellClass: 'flex items-center justify-center'
  };
  const columnsData = [...viewFormEntriesTableColumns(t), actionsColumn];

  function actionsTemplate(rowData) {
    return (
      <div className='flex items-center justify-center gap-1'>
        <EyeIcon
          onClick={() => {
            setSelectedPatientFormData(rowData?.formData);
            setOpenViewFormDataModal(true);
          }}
        />
      </div>
    );
  }

  const fetchInitialData = async () => {
    await executeFetch('GET', labModuleApi.generalResults.getAll(props?.patient_id));
  };

  useEffect(() => {
    fetchInitialData();
  }, [executeFetch]);

  useEffect(() => {
    if (data?.data?.length) {
      let tableRows = data?.data?.map(data => {
        let rowData = {
          created_at: formatDateTime(props?.created_at),
          full_name: props?.full_name,
          beneficiary_type: props?.beneficiary_type,
          file_no: props?.file_no,
          nationality: props?.nationality,
          formData: data
        };
        return rowData;
      });
      setTableData(tableRows);
    }
  }, [data]);

  return (
    <div className='w-full h-full'>
      <CustomTable isLoading={loading} data={tableData} columns={columnsData} />
      <ReusableModal
        className='w-full md:w-[650px] lg:w-[800px] xl:w-[900px] relative'
        isVisible={openViewFormDataModal}
        position='top'
        title={'General Form Results'}
        HeaderIcon={FaInfoCircle}
        onClose={() => {
          setOpenViewFormDataModal(false);
          setSelectedPatientFormData(null);
        }}
      >
        <FormsResultsPreviewTable selectedPatientFormData={selectedPatientFormData} />
      </ReusableModal>
    </div>
  );
};

export default ViewGeneralFormEntries;
